import React from 'react';
import _ from 'lodash';

import PropTypes from 'prop-types';
import {
  Table as QuoteApprovalDashboardTable,
  Thead,
  Tbody,
  Tr,
  Th
} from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import Rows from './Rows';

const Table = ({ pageLayout, data, removeData }) => {
  const handleRemoveData = orderID => removeData(orderID);

  return (
    <QuoteApprovalDashboardTable>
      <Thead style={{ background: '#e2e2e2' }}>
        <Tr>
          <Th />
          {_.get(pageLayout, 'tableHeaders', []).map(header => (
            <Th key={_.get(header, 'sys.id', '')}>
              {_.get(header, 'fields.title', '')}
            </Th>
          ))}
        </Tr>
      </Thead>
      <Tbody>
        {data &&
          data.map((order, index) => (
            <Rows
              key={order.id}
              index={index}
              order={order}
              pageLayout={pageLayout}
              removeData={handleRemoveData}
            />
          ))}
      </Tbody>
    </QuoteApprovalDashboardTable>
  );
};

Table.propTypes = {
  pageLayout: PropTypes.objectOf(PropTypes.object).isRequired,
  removeData: PropTypes.func.isRequired,
  data: PropTypes.objectOf(PropTypes.array).isRequired
};

export default Table;
